module.exports = __webpack_public_path__ + "static/media/pagseguro-safe.bafb9d9c.svg";